import { kebabCase } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Card, CardBody, CardHeader, Row, ButtonGroup } from 'reactstrap';
import Icon from './icon';
const ListPanel = ({
  actionButton: _actionButton = null,
  favoriteButton: _favoriteButton = null,
  children: _children = null,
  controlInfo: _controlInfo = null,
  onAdd: _onAdd = null,
  showNew: _showNew = false,
  newDisabled: _newDisabled = false,
  title: _title = '',
  titleAfter: _titleAfter = null,
  titleSub: _titleSub = null
}) => {
  const header = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Row, {
    className: "t-list-panel-header"
  }, /*#__PURE__*/React.createElement(Col, {
    sm: 9
  }, /*#__PURE__*/React.createElement("h3", {
    className: `t-main-title t-lp-title-${kebabCase(_title)}`
  }, _title, _titleAfter ? /*#__PURE__*/React.createElement("span", {
    className: "d-inline-flex align-items-center t-lp-title-after",
    style: {
      fontSize: '0.85em'
    }
  }, "\xA0", _titleAfter) : null), _titleSub ? /*#__PURE__*/React.createElement("div", {
    className: "small text-muted t-lp-subtitle"
  }, _titleSub) : null), /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement("div", {
    className: "float-md-right"
  }, /*#__PURE__*/React.createElement(ButtonGroup, null, _controlInfo, _favoriteButton, _actionButton, _showNew ? /*#__PURE__*/React.createElement(Button, {
    className: "t-button-new",
    id: "t-button-new",
    "data-testid": "t-button-new",
    size: "sm",
    disabled: _newDisabled,
    onClick: _onAdd
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "plus"
  }), " New") : undefined)))));
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    className: "card-heading"
  }, header), /*#__PURE__*/React.createElement(CardBody, null, _children));
};
ListPanel.propTypes = {
  actionButton: PropTypes.element,
  favoriteButton: PropTypes.element,
  children: PropTypes.node,
  controlInfo: PropTypes.node,
  onAdd: PropTypes.func,
  showNew: PropTypes.bool,
  newDisabled: PropTypes.bool,
  title: PropTypes.string,
  titleAfter: PropTypes.node,
  titleSub: PropTypes.node
};
export default ListPanel;